import { Tooltip } from 'antd';
import React from 'react';
import { UserAvatar } from './UserAvatar';

export interface AvatarRowProps {
  users?: { name: string; avatar?: string; email: string }[]
  size?: number
}

export const AvatarRow: React.FC<AvatarRowProps> = (props) => {
  const { users = [], size = 32 } = props

  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'row nowrap',
        marginRight: size / 2.25,
      }}
    >
      {users.map((user, i) => (
        <Tooltip key={i} title={user.name}>
          <UserAvatar
            src={user.avatar}
            name={user.name || user.email}
            size={size}
            style={{
              marginRight: -(size / 2.25),
              border: '2px solid #f9f9f9',
              backgroundColor: '#ebebeb',
              borderRadius: size / 2,
            }}
          />
        </Tooltip>
      ))}
    </div>
  )
}
